// User service for API calls

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const userService = {
  // Get all users for admin interface
  getAllUsers: async () => {
    const token = localStorage.getItem('authToken');
    
    const response = await fetch(`${API_BASE_URL}/users/admin/all`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    return response.json();
  },

  // Get user by ID
  getUserById: async (userId, includePassword = false) => {
    const token = localStorage.getItem('authToken');
    const url = includePassword 
      ? `${API_BASE_URL}/users/${userId}?include_password=true`
      : `${API_BASE_URL}/users/${userId}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    return response.json();
  },

  // Update user (admin endpoint with role change handling)
  updateUser: async (userId, userData) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/users/${userId}/admin-update`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    return response.json();
  },

  // Create user
  createUser: async (userData) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/users/create`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    return response.json();
  },

  // Get users with pagination
  getUsersWithPagination: async (skip = 0, limit = 100, includeInactive = false) => {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/users/?skip=${skip}&limit=${limit}&include_inactive=${includeInactive}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  },
};

export { userService };
export default userService;
